import SignedUrlMedia from './signedUrlMedia.js';
export default SignedUrlMedia;
